import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Typography, colors } from 'kangarootime-ui';
import RoomInitialsLabel from './RoomInitialsLabel';
import { capitalize } from '../../../../../../utils/string';

const RoomLabel = ({
  name,
  projectedAttendenceAM,
  projectedAttendencePM,
  groupColor,
  showInitials,
  ratio,
  ...props
}) => {
  const projectedAttendence = projectedAttendenceAM && projectedAttendencePM ? `${projectedAttendenceAM}AM / ${projectedAttendencePM}PM` : '';
  const initials = name.trim().split(' ').map(word => capitalize(word).charAt(0)).join('');

  return (
    <div className='flex-columns' style={{ backgroundColor: '#F5F6F7', minHeight: 40, justifyContent: 'center' }}>
      <div className='flex-rows' style={{ alignItems: 'center', margin: '0 8px' }}>
        <div className='flex-rows flex-1' style={{ alignItems: 'center', minHeight: 28 }}>
          { showInitials &&
            <Fragment>
              <div>
                <RoomInitialsLabel groupColor={groupColor}>{initials}</RoomInitialsLabel>
              </div>
              <div style={{ marginLeft: 8 }}>
                <Typography type='header' style={{ fontSize: '0.75rem', lineHeight: 'normal' }}>{name}</Typography>
                { ratio && <Typography style={{ color: colors.raven, fontSize: '0.625rem', fontWeight: 600, lineHeight: 'normal' }}>Ratio 1:{ratio}</Typography> }
                {/* 'Unassigned' wouldn't have a ratio so thats why it's a conditional render */}
              </div>
            </Fragment>
          }
        </div>
        <div>
          <Typography style={{
            color: colors.raven,
            fontSize: '0.625rem',
            lineHeight: 'normal',
            whiteSpace: 'nowrap'
          }}>{projectedAttendence}</Typography>
        </div>
      </div>
    </div>
  );
};

RoomLabel.propTypes = {
  name: PropTypes.string,
  projectedAttendenceAM: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  projectedAttendencePM: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  groupColor: PropTypes.string,
  showInitials: PropTypes.bool,
  ratio: PropTypes.number
};

export default RoomLabel;
